import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { CLIENT_EQUIPMENT_TYPES } from '../../utils/constants';

const UserSelector = ({ 
  darkMode, 
  activeAccordion, 
  setActiveAccordion, 
  handleUserClick,
  systems // Geçerli sistemleri ekleyelim
}) => {
  const clientEquipment = CLIENT_EQUIPMENT_TYPES;
  const [activeSystemId, setActiveSystemId] = useState(null);

  // Sistem seçimini render et
  const renderSystemSelector = () => {
    if (systems?.length === 0) {
      return (
        <div className={`text-center my-2 p-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          Lütfen önce bir sistem ekleyin.
        </div>
      );
    }

    return (
      <div className="mb-3">
        <label className={`text-sm font-medium ${darkMode ? 'text-gray-300' : 'text-gray-600'} block mb-2`}>
          Ekipman değiştirilecek sistemi seçin:
        </label>
        <select
          value={activeSystemId || ''}
          onChange={(e) => setActiveSystemId(e.target.value)}
          className={`w-full p-2 rounded-md ${
            darkMode ? 'bg-gray-700 text-gray-200 border-gray-600' : 'bg-gray-50 text-gray-700 border-gray-300'
          } border`}
        >
          <option value="">Sistem Seçin</option>
          {systems.map(system => (
            <option key={system.id} value={system.id}>
              {system.name}
            </option>
          ))}
        </select>
      </div>
    );
  };

  // Ekipman seçildiğinde, seçilen sistem için kullanıcı ekipmanını güncelleyelim
  const handleEquipmentSelect = (equipment) => {
    if (!activeSystemId && systems?.length > 0) {
      // Eğer aktif sistem seçilmemişse en son sistemi kullan
      setActiveSystemId(systems[systems.length - 1].id);
    }

    // Burada handleUserClick'i çağırıyoruz ve sistem ID'sini ekliyoruz
    handleUserClick({
      action: 'updateClientEquipment',
      equipmentType: equipment,
      systemId: activeSystemId || (systems?.length > 0 ? systems[systems.length - 1].id : null)
    });
  };

  return (
    <div className={`border ${darkMode ? 'border-gray-600' : 'border-gray-300'} rounded-lg overflow-hidden w-full`}>
      <div 
        className={`p-4 ${darkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-800'} cursor-pointer flex justify-between items-center`}
        onClick={() => setActiveAccordion(activeAccordion === 'users' ? null : 'users')}
      >
        <div className="flex items-center">
          <span className="font-medium text-lg">Kullanıcılar</span>
        </div>
        <ChevronDown 
          size={20} 
          className={`transform transition-transform ${activeAccordion === 'users' ? 'rotate-180' : 'rotate-0'}`} 
        />
      </div>
      
      {activeAccordion === 'users' && (
        <div className="p-4">
          {/* Önce sistem seçicisini göster */}
          {renderSystemSelector()}

          <div className="flex flex-col space-y-3">
            {clientEquipment.map((equipment) => (
              <div
                key={equipment.id}
                onClick={() => handleEquipmentSelect(equipment)}
                className={`flex items-center p-3 rounded-lg cursor-pointer transition-all hover:scale-102 ${
                  darkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-50 hover:bg-gray-100'
                }`}
              >
                {/* Büyük görsel */}
                <div className="flex-shrink-0 mr-4 w-20 h-20 flex items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20">
                  <img 
                    src={equipment.imgSrc} 
                    alt={equipment.name} 
                    className="h-16 w-16 object-contain" 
                  />
                </div>
                {/* Yanındaki metin */}
                <div>
                  <div className={`font-medium text-lg ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                    {equipment.name}
                  </div>
                  <div className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    {equipment.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserSelector;